import type { FieldPolicy } from "@apollo/client"

export const invitationCacheFields: Record<string, FieldPolicy> = {
  getInvitationById: {
    merge: false,
    read(_, { args, toReference, canRead }) {
      if (!args?.id) return
      const ref = toReference({ __typename: "UserInvitation", Id: args.id })
      if (ref && canRead(ref)) return ref
    },
  },
}
